import { PermissionType } from '@/type';
import { HcLinearAuth } from '@hclinear/hc-linear-react';

export const hasDashboardViewPermission = () =>
  hasPermission([PermissionType.PERM_MENU_DASHBOARD_VIEW]);

export const hasPermission = (requiredRoles: PermissionType[]): boolean => {
  return HcLinearAuth.hasUserRoles(requiredRoles);
};
